import mock from "@/@fake-db/mock";

const date = new Date();
const nextDay = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
// prettier-ignore
const nextMonth = date.getMonth() === 11 ? new Date(date.getFullYear() + 1, 0, 1) : new Date(date.getFullYear(), date.getMonth() + 1, 1)
// prettier-ignore
const prevMonth = date.getMonth() === 11 ? new Date(date.getFullYear() - 1, 0, 1) : new Date(date.getFullYear(), date.getMonth() - 1, 1)

const data = {
  events: [
    {
      id: 1,
      url: "",
      title: "First Day of School",
      start: new Date(date.getFullYear(), 0, 1),
      end: new Date(date.getFullYear(), 0, 1, 12, 0, 0, 0),
      allDay: false,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 2,
      url: "",
      title: "Monthly Quiz",
      start: new Date(date.getFullYear(), date.getMonth() + 1, -1),
      end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
      allDay: true,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 3,
      url: "",
      title: "Parents Trip",
      allDay: true,
      start: new Date(date.getFullYear(), date.getMonth() + 1, -9),
      end: new Date(date.getFullYear(), date.getMonth() + 1, -7),
      extendedProps: {
        calendar: "Holiday",
      },
    },
    {
      id: 4,
      url: "",
      title: "Graduation Ceremony",
      start: new Date(date.getFullYear(), date.getMonth() + 1, -11),
      end: new Date(date.getFullYear(), date.getMonth() + 1, -10),
      allDay: true,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 5,
      url: "",
      title: "Dart Game?",
      start: new Date(date.getFullYear(), date.getMonth() + 1, -13),
      end: new Date(date.getFullYear(), date.getMonth() + 1, -12),
      allDay: true,
      extendedProps: {
        calendar: "ETC",
      },
    },
    {
      id: 6,
      url: "",
      title: "Field Trip",
      start: new Date(date.getFullYear(), 0, 6),
      end: new Date(date.getFullYear(), 0, 7),
      allDay: true,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 7,
      url: "",
      title: "Staff Dinner",
      start: new Date(date.getFullYear(), 0, 21),
      end: new Date(date.getFullYear(), 0, 22),
      allDay: true,
      extendedProps: {
        calendar: "Staff",
      },
    },
    {
      id: 8,
      url: "",
      title: "Staff Meeting",
      start: new Date(date.getFullYear(), date.getMonth() + 1, -13),
      end: new Date(date.getFullYear(), date.getMonth() + 1, -12),
      allDay: true,
      extendedProps: {
        calendar: "Staff",
      },
    },
    {
      id: 9,
      url: "",
      title: "PTM",
      start: new Date(date.getFullYear(), date.getMonth() + 1, 1),
      end: new Date(date.getFullYear(), date.getMonth() + 1, 2),
      allDay: true,
      extendedProps: {
        calendar: "Parents",
        classID: [],
        secID: [],
      },
    },
    {
      id: 10,
      url: "",
      title: "Monthly Checkup",
      start: prevMonth,
      end: prevMonth,
      allDay: true,
      extendedProps: {
        calendar: "Staff",
      },
    },
  ],
  academicEvents: [
    {
      id: 1,
      url: "",
      title: "First Day of School",
      start: new Date(date.getFullYear(), 0, 1),
      end: new Date(date.getFullYear(), 0, 1, 12, 0, 0, 0),
      allDay: false,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 2,
      url: "",
      title: "Monthly Quiz",
      start: new Date(date.getFullYear(), date.getMonth() + 1, -1),
      end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
      allDay: true,
      extendedProps: {
        calendar: "Students",
        classID: [0],
        secID: [0],
      },
    },
    {
      id: 9,
      url: "",
      title: "PTM",
      start: new Date(date.getFullYear(), date.getMonth() + 1, 1),
      end: new Date(date.getFullYear(), date.getMonth() + 1, 2),
      allDay: true,
      extendedProps: {
        calendar: "Parents",
        classID: [],
        secID: [],
      },
    },
    {
      id: 10,
      url: "",
      title: "Monthly Checkup",
      start: prevMonth,
      end: prevMonth,
      allDay: true,
      extendedProps: {
        calendar: "Staff",
      },
    },
  ],
};

// ------------------------------------------------
// GET: Return calendar events
// ------------------------------------------------
mock.onGet("/apps/calendar/events").reply((config) => {
  // Get requested calendars as Array
  const calendars = config.params.calendars.split(",");

  return [
    200,
    data.events.filter((event) =>
      calendars.includes(event.extendedProps.calendar)
    ),
  ];
});

// ------------------------------------------------
// POST: Add new event
// ------------------------------------------------
mock.onPost("/apps/calendar/events").reply((config) => {
  // Get event from post data
  const { event } = JSON.parse(config.data);

  const { length } = data.events;
  let lastIndex = 0;
  if (length) {
    lastIndex = data.events[length - 1].id;
  }
  event.id = lastIndex + 1;

  data.events.push(event);

  return [201, { event }];
});

// ------------------------------------------------
// POST: Update Event
// ------------------------------------------------
mock.onPost(/\/apps\/calendar\/events\/\d+/).reply((config) => {
  const { event: eventData } = JSON.parse(config.data);

  // Convert Id to number
  eventData.id = Number(eventData.id);

  const event = data.events.find((e) => e.id === Number(eventData.id));
  Object.assign(event, eventData);

  return [200, { event }];
});

// ------------------------------------------------
// DELETE: Remove Event
// ------------------------------------------------
mock.onDelete(/\/apps\/calendar\/events\/\d+/).reply((config) => {
  // Get event id from URL
  let eventId = config.url.substring(config.url.lastIndexOf("/") + 1);

  // Convert Id to number
  eventId = Number(eventId);

  const eventIndex = data.events.findIndex((e) => e.id === eventId);
  data.events.splice(eventIndex, 1);
  return [200];
});

// ========= Academic calendar ==============

// ------------------------------------------------
// GET: Return calendar events
// ------------------------------------------------
mock.onGet("/apps/calendar/academicevents").reply((config) => {
  // Get requested calendars as Array
  const calendars = config.params.calendars.split(",");

  return [
    200,
    data.academicEvents.filter((event) =>
      calendars.includes(event.extendedProps.calendar)
    ),
  ];
});

// ------------------------------------------------
// POST: Add new event
// ------------------------------------------------
mock.onPost("/apps/calendar/academicevents").reply((config) => {
  // Get event from post data
  const { event } = JSON.parse(config.data);

  const { length } = data.academicEvents;
  let lastIndex = 0;
  if (length) {
    lastIndex = data.academicEvents[length - 1].id;
  }
  event.id = lastIndex + 1;

  data.academicEvents.push(event);

  return [201, { event }];
});

// ------------------------------------------------
// POST: Update Event
// ------------------------------------------------
mock.onPost(/\/apps\/calendar\/academicevents\/\d+/).reply((config) => {
  const { event: eventData } = JSON.parse(config.data);

  // Convert Id to number
  eventData.id = Number(eventData.id);

  const event = data.academicEvents.find((e) => e.id === Number(eventData.id));
  Object.assign(event, eventData);

  return [200, { event }];
});

// ------------------------------------------------
// DELETE: Remove Event
// ------------------------------------------------
mock.onDelete(/\/apps\/calendar\/academicevents\/\d+/).reply((config) => {
  // Get event id from URL
  let eventId = config.url.substring(config.url.lastIndexOf("/") + 1);

  // Convert Id to number
  eventId = Number(eventId);

  const eventIndex = data.academicEvents.findIndex((e) => e.id === eventId);
  data.academicEvents.splice(eventIndex, 1);
  return [200];
});
